import { render, staticRenderFns } from "./CruiseDetailBase.vue?vue&type=template&id=2818be63&scoped=true&"
import script from "./CruiseDetailBase.vue?vue&type=script&lang=js&"
export * from "./CruiseDetailBase.vue?vue&type=script&lang=js&"
import style0 from "./CruiseDetailBase.vue?vue&type=style&index=0&id=2818be63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2818be63",
  null
  
)

export default component.exports